<app-tabla
  [totalCount]="totalCount"
  [datos]="codigosDispositivos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [crear]="botonCrear"
  [emptyState]="{ title: 'Todavía no hay códigos' }"
></app-tabla>
